import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope, faLock } from "@fortawesome/free-solid-svg-icons";
import { Input, Button, InputContainer, Icon, LoginBox } from "./AdminStyles";

const LoginForm = ({ handleLogin, message }) => {
  const [form, setForm] = useState({ username: "", password: "" });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // const loginData = {
    //   username: form.username,
    //   password: form.password,
    // };

    handleLogin(form.username, form.password);
  };

  return (
    <LoginBox>
      <img src="/assets/logo.jpg" style={{ width: "100%" }} alt="Logo" />
      <form onSubmit={handleSubmit}>
        <InputContainer>
          <Icon>
            <FontAwesomeIcon icon={faEnvelope} />
          </Icon>
          <Input
            type="email"
            name="username"
            placeholder="Email"
            value={form.username}
            onChange={handleChange}
            required
            style={{ border: "none" }}
          />
        </InputContainer>

        <InputContainer>
          <Icon>
            <FontAwesomeIcon icon={faLock} />
          </Icon>
          <Input
            type="password"
            name="password"
            placeholder="Password"
            value={form.password}
            onChange={handleChange}
            required
            style={{ border: "none" }}
          />
        </InputContainer>

        <Button type="submit" style={{ width: "100%" }}>
          Login
        </Button>
      </form>

      {/* Display the message if available */}
      {message && <p style={{ color: "red", marginTop: "20px" }}>{message}</p>}
    </LoginBox>
  );
};

export default LoginForm;
